import { render, staticRenderFns } from "./UpgradeToPremiumLink.vue?vue&type=template&id=2c780958&"
import script from "./UpgradeToPremiumLink.vue?vue&type=script&lang=js&"
export * from "./UpgradeToPremiumLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports